// src/components/MessageBox.jsx
import React from 'react';
import './JoinEarlyBox.css'; // ✅ Reuse same styling

const MessageBox = ({ icon = '💡', text = '' }) => {
  const fullMessage = `${icon} ${text}`;
  return (
    <div className="join-early-box">
      <span>{fullMessage}</span>
    </div>
  );
};

export default MessageBox;
